import { useChartererStore } from '../context/ChartererContext';
import { useAppSettings } from './useAppSettings';
import useApi from '../api/useApi';

/**
 * Custom hook for fetching charterers list
 * Loads all charterers and stores them in ChartererContext
 */
const useGetCharterers = () => {
    const { getApiData } = useApi();
    const { setCharterers, setIsLoading } = useChartererStore();
    const { settings: appSettings } = useAppSettings();

    const getCharterers = async () => {
        try {
            const apiUrl = appSettings?.api;
            if (!apiUrl) {
                console.warn('[useGetCharterers] API URL not configured, skipping charterers load');
                return;
            }

            setIsLoading(true);

            const response = await getApiData({
                endpoint: `${apiUrl}GetCharterers`,
            });

            if (Array.isArray(response)) {
                setCharterers(response);
            }
        } catch (error) {
            console.error('[useGetCharterers] Error fetching charterers (non-critical):', error);
        } finally {
            setIsLoading(false);
        }
    };

    return { getCharterers };
};

export default useGetCharterers;
